import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "BaseDataService",
  controller: "Equipment",
};

const methods = [
  "AddItem",
  "UpdateItem",
  "DelItem",
  "DelItemList",
  "FindByConditions",
  "GetEquipmentPagingList",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const BaseDataApi = ZJApi.defineNewApi("BaseDataApi", factory);

export default BaseDataApi;
